var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-bg" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-card",
          attrs: {
            id: "notification",
            title: _vm.$t("tips.document_requirement"),
            visible: _vm.dialogVisible,
            width: "836px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "text-bg-1" }, [
              _c("span", { staticClass: "text-lift" }, [
                _vm._v(_vm._s(_vm.$t("tips.contract_basic_review_title"))),
              ]),
              _c("span", { staticClass: "text-right" }, [
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(_vm._s(_vm.$t("tips.contract_basic_review_1"))),
                ]),
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(_vm._s(_vm.$t("tips.contract_basic_review_2"))),
                ]),
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(_vm._s(_vm.$t("tips.contract_basic_review_3"))),
                ]),
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(_vm._s(_vm.$t("tips.contract_basic_review_4"))),
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("tips.contract_basic_review_5"))),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "header-line" }),
            _c("div", { staticClass: "text-bg-2" }, [
              _c("span", { staticClass: "text-lift" }, [
                _vm._v(_vm._s(_vm.$t("tips.contract_entity_title"))),
              ]),
              _c("span", { staticClass: "text-right" }, [
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(_vm._s(_vm.$t("tips.contract_entity_1"))),
                ]),
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(_vm._s(_vm.$t("tips.contract_entity_2"))),
                ]),
                _c("div", [_vm._v(_vm._s(_vm.$t("tips.contract_entity_3")))]),
              ]),
            ]),
            _c("div", { staticClass: "header-line" }),
            _c("div", { staticClass: "text-bg-1" }, [
              _c("span", { staticClass: "text-lift" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("tips.contractual_rights_and_obligations_title")
                  )
                ),
              ]),
              _c("span", { staticClass: "text-right" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("tips.contractual_rights_and_obligations_1"))
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "header-line" }),
            _c("div", { staticClass: "text-bg-2" }, [
              _c("span", { staticClass: "text-lift" }, [
                _vm._v(
                  _vm._s(_vm.$t("tips.contract_object_quantity_quality_title"))
                ),
              ]),
              _c("span", { staticClass: "text-right" }, [
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(
                    _vm._s(_vm.$t("tips.contract_object_quantity_quality_1"))
                  ),
                ]),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("tips.contract_object_quantity_quality_2"))
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "header-line" }),
            _c("div", { staticClass: "text-bg-1" }, [
              _c("span", { staticClass: "text-lift" }, [
                _vm._v(
                  _vm._s(_vm.$t("tips.contract_price_or_compensation_title"))
                ),
              ]),
              _c("span", { staticClass: "text-right" }, [
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(
                    _vm._s(_vm.$t("tips.contract_price_or_compensation_1"))
                  ),
                ]),
                _c("div", { staticClass: "mb-16" }, [
                  _vm._v(
                    _vm._s(_vm.$t("tips.contract_price_or_compensation_2"))
                  ),
                ]),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("tips.contract_price_or_compensation_3"))
                  ),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }